const FILTERS_LIST = [
  { id: 1, label: 'Black & White', className: 'billy-dom__filter_bw' },
  { id: 2, label: 'Sepia', className: 'billy-dom__filter_sepia' },
  { id: 3, label: 'Saturate', className: 'billy-dom__filter_saturate' }
]

export { 
  FILTERS_LIST
};


// WEBPACK FOOTER //
// ./src/constants/filtersList.js